<template>
  <div>
    <div class="min-vh">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="4" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">MESSAGE LOG DETAIL</h1>
        </b-col>
        <b-col xl="8" class="text-left text-xl-right">
          <b-button @click="exportExcel(1)" class="export-button">
            <div>
              <font-awesome-icon icon="file-export" />
              <span class="ml-2"> EXPORT TO EXCEL </span>
            </div>
          </b-button>
        </b-col>
      </CRow>
      <div class="mt-3 bg-white-border p-3" v-if="messageDetail">
        <b-row class="no-gutters my-3">
          <b-col cols="3">
            <div class="font-weight-bold">Time</div>
            <div>
              {{ formatDate(messageDetail.detail.createTime) }}
            </div>
          </b-col>
          <b-col>
            <div class="font-weight-bold">Message ID</div>
            <div class="message-log">
              {{ messageDetail.detail.messageId || "-" }}
            </div>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col cols="3">
            <div class="font-weight-bold">Customer Name</div>
            <div>{{ messageDetail.detail.socialName || "-" }}</div>
          </b-col>
          <b-col>
            <div class="font-weight-bold">Channel</div>
            <div class="tag-social" v-if="messageDetail.detail.channelId">
              <img
                :src="channelList[messageDetail.detail.channelId].imageUrl"
                alt=""
              />
              <span class="mb-0">{{ messageDetail.detail.channelName }}</span>
            </div>
            <div v-else>-</div>
          </b-col>
          <b-col>
            <div class="font-weight-bold">Topic</div>
            <div>{{ messageDetail.detail.topicName || "-" }}</div>
          </b-col>
          <b-col>
            <div class="font-weight-bold">Agent</div>
            <div>{{ messageDetail.detail.agentName || "-" }}</div>
          </b-col>
          <b-col>
            <div class="font-weight-bold">Resolution Time</div>
            <div>{{ messageDetail.detail.resolutionTimeText }}</div>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col>
            <div class="font-weight-bold">Frist Response Time</div>
            <div>
              {{ formatDate(messageDetail.detail.responseTime) }}
            </div>
          </b-col>
        </b-row>
        <b-row class="no-gutters my-3">
          <b-col>
            <p class="font-weight-bold mb-2">Message</p>
            <div class="border p-3">
              <template v-if="messageDetail.messageLogs.length">
                <b-row
                  class="no-gutters"
                  v-for="(item, index) in messageDetail.messageLogs"
                  v-bind:key="index"
                >
                  <b-col cols="2">
                    <!-- {{ formatDate(item.sendTime) }} -->
                    {{ new Date(item.sendTime) | moment($formatDateTime) }}
                  </b-col>
                  <b-col class="message-log">
                    {{ item.senderName || "-" }} : {{ item.message || "-" }}
                  </b-col>
                </b-row>
              </template>
              <div v-else>No data</div>
            </div>
          </b-col>
        </b-row>
        <!-- <b-row class="no-gutters my-3">
          <b-col>
            <div class="font-weight-bold mb-2">Row Request</div>
            <vue-json-pretty
              v-if="messageDetail.body"
              :data="messageDetail.body"
              :deep="4"
              :path="'res'"
              :deepCollapseChildren="true"
              :show-double-quotes="false"
              :show-length="false"
              :show-line="false"
              :collapsed-on-click-brackets="true"
            >
            </vue-json-pretty>
            <div v-else>-</div>
          </b-col>
          <b-col>
            <div class="font-weight-bold mb-2">Row Response</div>
            <vue-json-pretty
              v-if="messageDetail.responseMessage"
              :data="messageDetail.responseMessage"
              :deep="4"
              :path="'res'"
              :deepCollapseChildren="true"
              :show-double-quotes="false"
              :show-length="false"
              :show-line="false"
              :collapsed-on-click-brackets="true"
            >
            </vue-json-pretty>
            <div v-else>-</div>
          </b-col>
        </b-row> -->
        <b-row class="mt-5">
          <b-col>
            <b-button class="btn-details-set btn-cancel" @click="$router.go(-1)"
              >CANCEL</b-button
            >
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalLoading ref="modalLoading" :text="msgModal" :hasClose="false" />
  </div>
</template>

<script>
import ModalLoading from "@/components/modal/alert/ModalLoading";
// import VueJsonPretty from "vue-json-pretty";
// import "vue-json-pretty/lib/styles.css";
import moment from "moment";
export default {
  components: {
    ModalLoading,
    //   VueJsonPretty,
  },
  data() {
    return {
      msgModal: null,
      messageDetail: null,
      channelList: {},
    };
  },
  // filters: {
  //   pretty: function (value) {
  //     return JSON.stringify(JSON.parse(value), null, 2);
  //   },
  // },
  created: async function () {
    await this.getChannel();
    await this.getMessageDetailById();
  },
  methods: {
    getChannel: async function () {
      const url = `${this.$baseUrl}/analytics/Filter/Channel`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          await data.detail.forEach((item) => {
            this.channelList[item.id] = item;
          });
        }
      });
    },
    getMessageDetailById: async function () {
      let body = {
        messageId: this.$route.params.id,
        userMessageActivityId: this.$route.params.activityId,
      };
      await this.axios
        .post(`${this.$baseUrl}/MessageLog/GetMessageLogDetail`, body)
        .then((data) => {
          if (data.result === 1) {
            this.messageDetail = data.detail;
            // if (this.messageDetail.body) {
            //   this.messageDetail.body = JSON.parse(this.messageDetail.body);
            // }
            // if (this.messageDetail.responseMessage) {
            //   this.messageDetail.responseMessage = JSON.parse(
            //     this.messageDetail.responseMessage
            //   );
            // }
          }
        });
    },
    async exportExcel(typeNumber) {
      this.$refs.modalLoading.show();
      this.msgModal = "In progress";

      let body = {
        messageId: this.$route.params.id,
        userMessageActivityId: this.$route.params.activityId,
      };

      let path = "";
      let fileName = "";

      if (typeNumber == 1) {
        path = "messagelog/export/GetMessageLogDetail";
        fileName = `Message-Log-${this.messageDetail.detail.customerName}`;
      }

      try {
        await this.axios
          .post(`${this.$baseUrl}/${path}`, body, {
            responseType: "blob",
          })
          .then(async (response) => {
            this.$refs.modalLoading.hide();
            const isJsonBlob = (data) =>
              data instanceof Blob && data.type === "application/json";
            const responseData = isJsonBlob(response)
              ? await response?.text()
              : response || {};
            if (typeof responseData === "string") {
              const responseJson = JSON.parse(responseData);
              this.$refs.modalLoading.hide();
              this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
                isShow: true,
                msg: responseJson.message,
              });
            } else {
              var fileURL = window.URL.createObjectURL(new Blob([response]));
              var fileLink = document.createElement("a");

              fileLink.href = fileURL;
              fileLink.setAttribute("download", `${fileName}.xlsx`);
              document.body.appendChild(fileLink);
              fileLink.click();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$refs.modalLoading.hide();
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: error.message,
            });
          });
      } catch (err) {
        console.error(err);
        this.$refs.modalLoading.hide();
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: error.message,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tag-social {
  -ms-flex-pack: start !important;
  justify-content: start !important;
}
.export-button {
  background-color: #0d1731;
  color: #ffffff !important;
  min-width: 150px;
  font-weight: bold;
  transition: 0.3s;
  border-radius: 4px;
  border-color: #0d1731;
}
.message-log {
  word-wrap: break-word;
}
</style>
